module.exports = __webpack_public_path__ + "img/alumniLogo.91fa3609.svg";